export default "__VITE_ASSET__BVHq5u3j__"